module.exports = __webpack_public_path__ + "img/s4-3.0ac146bd.jpg";